export default __webpack_public_path__ + "8e38496feefd4f7f60d4fa7281b8762f.png";